import React from 'react';
import PropTypes from 'prop-types';
import Confirm from '../../confirm';

const InputFooter = ({
  t,
  id,
  onChange,
  onRemove,
  showDelete,
  showConfirm,
  hideConfirm,
  onRemoveCallback,
  tempFile,
}) => (
  <React.Fragment>
    <div className="foruploaddelete boxs">
      <label htmlFor={`${id}_footer`} className="btn_upload uplaodnew2 uploadnew posabuploadimage_title">
        {t('upload new?')}
      </label>
      <input
        id={`${id}_footer`}
        type="file"
        onChange={onChange}
        style={{ width: '0' }}
      />
      {
        tempFile && showDelete &&
                  (<input
                    type="button"
                    value={t('delete?')}
                    className="btn-rmv1 deleteimg deleteimg1"
                    onClick={onRemove}
                    style={{ display: 'inline-block', cursor: 'pointer' }}
                  />)
                }
    </div>
    <Confirm
      show={showConfirm}
      cancelCallback={hideConfirm}
      successCallback={onRemoveCallback}
    />
  </React.Fragment>
);

InputFooter.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  showDelete: PropTypes.bool,
  hideConfirm: PropTypes.func.isRequired,
  showConfirm: PropTypes.bool.isRequired,
  onRemoveCallback: PropTypes.func.isRequired,
  tempFile: PropTypes.bool,
};

export default InputFooter;



// WEBPACK FOOTER //
// ./src/components/inputFile/InputFooter/InputFooter.js